import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container",
  style: {"margin-top":"80px","padding-top":"40px"}
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-lg-6 text-right align-self-end" }
const _hoisted_4 = {
  class: "btn btn-outline-success mr-1",
  style: {"padding":"0.7em 2em"}
}
const _hoisted_5 = {
  key: 0,
  class: "table table-bordered table-hover mb-3"
}
const _hoisted_6 = { class: "text-muted" }
const _hoisted_7 = {
  class: "text-center align-middle",
  style: {"width":"150px"}
}
const _hoisted_8 = { class: "btn-group" }
const _hoisted_9 = { class: "dropdown-menu dropdown-menu-right" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = {
  class: "text-center align-middle",
  style: {"width":"70px"}
}
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "table-secondary" }
const _hoisted_14 = { style: {"width":"60px"} }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "text-muted" }
const _hoisted_17 = { class: "text-primary" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { class: "dropdown" }
const _hoisted_20 = { class: "dropdown-menu" }
const _hoisted_21 = { class: "dropdown-item" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = ["onClick"]
const _hoisted_24 = ["onClick"]
const _hoisted_25 = { class: "text-primary" }
const _hoisted_26 = { class: "text-muted" }
const _hoisted_27 = { key: 1 }
const _hoisted_28 = {
  colspan: "2",
  class: "text-center"
}
const _hoisted_29 = ["onClick"]

import { computed, onMounted, watch, shallowReactive, type Ref } from 'vue'
    import { useRoute } from 'vue-router'

    import { Refresh } from '@browser/Browser'
    import { generateName } from '@common/Common'
    import PortfolioNavigation from '@common/Components/PortfolioNavigation.vue'
    import { guid } from '@common/Guid'

    import PortfolioScenarioEditor from '@Quest/PortfolioScenarios/Components/PortfolioScenarioEditor.vue'
    import { PortfolioScenarioEditorViewModel } from '@Quest/PortfolioScenarios/Components/PortfolioScenarioEditor'

    import { usePortfolioScenariosPageQueryV1 } from '@Quest/PortfolioScenarios/queries-vue-composables'

    import
        {
            useClonePortfolioScenarioCommandV1,
            useConnectToCorporateScenarioCommandV1,
            useDeletePortfolioScenarioCommandV1
        } from '@Quest/PortfolioScenarios/commands-vue-composables'

    import { useExportAllActiveProjectPlansCommandV1 } from '@Quest/Portfolios/commands-vue-composables'

    import type {
        CorporateScenarioReadModel,
        PortfolioScenarioReadModel,
        PortfolioScenariosPageReadModel
    } from '@Quest/PortfolioScenarios/readmodels'

    import moment from 'moment'


    // ======================
    // Route
    // ======================

    
export default /*@__PURE__*/_defineComponent({
  __name: 'PortfolioScenariosPage',
  setup(__props) {

    const route = useRoute()

    const workspaceId = computed(() => Number(route.params.workspaceId ?? 0))
    const tchProjectId = computed(() => Number(route.params.tchProjectId ?? 0))


    // ======================
    // Query
    // ======================

    const {
        runPortfolioScenariosPageQueryV1,
        modelPortfolioScenariosPageQueryV1
    } = usePortfolioScenariosPageQueryV1(workspaceId, tchProjectId)

    const rm = modelPortfolioScenariosPageQueryV1 as Ref<PortfolioScenariosPageReadModel | null>
    const portfolioId = computed(() => rm.value?.PortfolioId)

    const {
        invokeClonePortfolioScenarioCommandV1,
        onSucceedClonePortfolioScenarioCommandV1
    } = useClonePortfolioScenarioCommandV1(workspaceId, portfolioId)

    const {
        invokeConnectToCorporateScenarioCommandV1,
        onSucceedConnectToCorporateScenarioCommandV1
    } = useConnectToCorporateScenarioCommandV1(workspaceId, portfolioId)

    const {
        invokeDeletePortfolioScenarioCommandV1,
        onSucceedDeletePortfolioScenarioCommandV1
    } = useDeletePortfolioScenarioCommandV1(workspaceId, portfolioId)

    const {
        invokeExportAllActiveProjectPlansCommandV1,
        onSucceedExportAllActiveProjectPlansCommandV1,
        result: resultExportAllActiveProjectPlansCommandV1
    } = useExportAllActiveProjectPlansCommandV1(workspaceId, portfolioId)


    const portfolioScenarioEditor = shallowReactive(new PortfolioScenarioEditorViewModel())


    // ======================
    // Formatting
    // ======================

    function formatDate(date: Date | null)
    {
        if (!date) return null
        return moment(date).format('MMM D, YYYY')
    }

    function formatTime(date: Date | null)
    {
        if (!date) return null
        return moment(date).format('LT')
    }


    // ======================
    // Actions
    // ======================

    function showPortfolioScenarioCreator(cScenarioId: string)
    {
        portfolioScenarioEditor.showCreator(
            workspaceId.value,
            portfolioId.value,
            cScenarioId
        )
    }

    function showPortfolioScenarioEditor(pScenario: PortfolioScenarioReadModel)
    {
        portfolioScenarioEditor.showEditor(
            workspaceId.value,
            portfolioId.value,
            pScenario.Id
        )
    }

    function handleConnectToCorporateScenarioCommand(
        pScenario: PortfolioScenarioReadModel,
        cScenario: CorporateScenarioReadModel
    )
    {
        invokeConnectToCorporateScenarioCommandV1({
            Id: pScenario.Id,
            CorporateScenarioId: cScenario.Id
        })
    }

    function handleClonePortfolioScenarioCommand(s: PortfolioScenarioReadModel)
    {
        invokeClonePortfolioScenarioCommandV1({
            SourceId: s.Id,
            Id: guid(),
            CloneName: generateName(s.Name)
        })
    }

    function handleDeletePortfolioScenarioCommand(scenarioId: string)
    {
        if (confirm('Are you sure?') === true)
        {
            invokeDeletePortfolioScenarioCommandV1({ Id: scenarioId })
        }
    }

    function handleExportAllActiveProjectPlansCommand()
    {
        invokeExportAllActiveProjectPlansCommandV1()
    }

    function onScenarioCreated()
    {
        Refresh()
    }

    function onScenarioUpdated()
    {
        Refresh()
    }

    onMounted(() =>
    {
        document.title = 'Portfolio Plans'
        runPortfolioScenariosPageQueryV1()
    })

    watch(rm, (model) =>
    {
        if (!model) return

        if (model.RedirectUrl)
        {
            location.href = model.RedirectUrl
        }
    })


    onSucceedClonePortfolioScenarioCommandV1(() =>
    {
        Refresh()
    })

    onSucceedDeletePortfolioScenarioCommandV1(() =>
    {
        Refresh()
    })

    onSucceedConnectToCorporateScenarioCommandV1(() =>
    {
        Refresh()
    })

    onSucceedExportAllActiveProjectPlansCommandV1(() =>
    {
        location.href = resultExportAllActiveProjectPlansCommandV1.value
    })



return (_ctx: any,_cache: any) => {
  const _directive_sanitizedHref = _resolveDirective("sanitizedHref")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(PortfolioScenarioEditor, {
      viewModel: _unref(portfolioScenarioEditor),
      onScenarioCreated: onScenarioCreated,
      onScenarioUpdated: onScenarioUpdated
    }, null, 8 /* PROPS */, ["viewModel"]),
    _createVNode(PortfolioNavigation, {
      workspaceId: workspaceId.value,
      projectId: tchProjectId.value
    }, null, 8 /* PROPS */, ["workspaceId", "projectId"]),
    (_unref(rm))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "col-lg-6" }, [
              _createElementVNode("h1", { style: {"font-size":"2em","font-weight":"300","color":"#33475b","margin":"0"} }, "Planning")
            ], -1 /* CACHED */)),
            _createElementVNode("div", _hoisted_3, [
              _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_4, [...(_cache[0] || (_cache[0] = [
                _createTextVNode("Enterprise plans", -1 /* CACHED */)
              ]))])), [
                [_directive_sanitizedHref, `/#/enterprise/planning/${_unref(rm).StrategyWorkspaceId}/${_unref(rm).StrategyId}`]
              ]),
              _cache[1] || (_cache[1] = _createElementVNode("a", {
                class: "btn btn-lg btn-outline-secondary",
                href: "https://www.transparentchoice.com/client-hub/user-guide/scenarios",
                title: "Documentation",
                target: "_blank"
              }, [
                _createElementVNode("i", {
                  class: "fa fa-info",
                  "aria-hidden": "true"
                })
              ], -1 /* CACHED */)),
              _createCommentVNode("<div class=\"dropdown d-inline\">\n                        <button class=\"btn btn-outline-secondary dropdown-toggle\" data-toggle=\"dropdown\" style=\"padding: 0.7em 2em;\">\n                            Actions\n                        </button>\n                        <div class=\"dropdown-menu dropdown-menu-right dropdown-menu-scrollable\" role=\"menu\">\n                            <a class=\"dropdown-item\" v-sanitizedHref=\"`/#/portfolio/import/${workspaceId}/${tchProjectId}`\">Import business cases</a>\n                            <a class=\"dropdown-item\" @click=\"handleExportAllActiveProjectPlansCommand\">Export business cases</a>\n                        </div>\n                    </div>")
            ])
          ]),
          _cache[13] || (_cache[13] = _createElementVNode("hr", { style: {"border-color":"#bbb","margin":"20px 0 60px"} }, null, -1 /* CACHED */)),
          (_unref(rm).NotConnectedScenarios.length)
            ? (_openBlock(), _createElementBlock("table", _hoisted_5, [
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(rm).NotConnectedScenarios, (s) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: s.Id,
                      class: "table-danger"
                    }, [
                      _createElementVNode("td", null, [
                        _createTextVNode(_toDisplayString(s.Name), 1 /* TEXT */),
                        _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                        _createElementVNode("small", _hoisted_6, "Created: " + _toDisplayString(formatDate(s.CreatedDate)) + ", " + _toDisplayString(formatTime(s.CreatedDate)) + " by " + _toDisplayString(s.CreatedByName), 1 /* TEXT */)
                      ]),
                      _createElementVNode("td", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                          _cache[4] || (_cache[4] = _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-outline-secondary dropdown-toggle",
                            "data-toggle": "dropdown"
                          }, " Connect ", -1 /* CACHED */)),
                          _createElementVNode("div", _hoisted_9, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(rm).CorporateScenarios, (cs) => {
                              return (_openBlock(), _createElementBlock("a", {
                                key: cs.Id,
                                class: "dropdown-item",
                                onClick: ($event: any) => (handleConnectToCorporateScenarioCommand(s, cs))
                              }, _toDisplayString(cs.Name), 9 /* TEXT, PROPS */, _hoisted_10))
                            }), 128 /* KEYED_FRAGMENT */))
                          ])
                        ])
                      ]),
                      _createElementVNode("td", _hoisted_11, [
                        _createElementVNode("button", {
                          class: "btn btn-outline-secondary",
                          onClick: ($event: any) => (handleDeletePortfolioScenarioCommand(s.Id))
                        }, [...(_cache[5] || (_cache[5] = [
                          _createElementVNode("i", { class: "fa-regular fa-trash-can" }, null, -1 /* CACHED */)
                        ]))], 8 /* PROPS */, _hoisted_12)
                      ])
                    ]))
                  }), 128 /* KEYED_FRAGMENT */))
                ])
              ]))
            : _createCommentVNode("v-if", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(rm).CorporateScenarios, (cs) => {
            return (_openBlock(), _createElementBlock("table", {
              class: "table table-bordered table-hover",
              key: cs.Id
            }, [
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", _hoisted_13, [
                  _createElementVNode("td", _hoisted_14, [
                    _createElementVNode("button", {
                      class: "btn btn-outline-secondary",
                      onClick: ($event: any) => (cs.IsCollapsed = !cs.IsCollapsed)
                    }, [
                      _createElementVNode("i", {
                        class: _normalizeClass(['fa', cs.IsCollapsed ? 'fa-chevron-down' : 'fa-chevron-up'])
                      }, null, 2 /* CLASS */)
                    ], 8 /* PROPS */, _hoisted_15)
                  ]),
                  _createElementVNode("td", null, [
                    _cache[6] || (_cache[6] = _createElementVNode("span", { class: "badge badge-primary float-right" }, "Enterprise plan", -1 /* CACHED */)),
                    _createElementVNode("small", _hoisted_16, _toDisplayString(formatDate(cs.StartDate)) + " - " + _toDisplayString(formatDate(cs.EndDate)), 1 /* TEXT */),
                    _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                    _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_17, [
                      _createTextVNode(_toDisplayString(cs.Name), 1 /* TEXT */)
                    ])), [
                      [_directive_sanitizedHref, `/#/enterprise-plan/portfolios/${_unref(rm).StrategyWorkspaceId}/${_unref(rm).StrategyId}/${cs.Id}`]
                    ]),
                    (cs.IsCollapsed === false)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                          _createElementVNode("small", null, _toDisplayString(cs.Description), 1 /* TEXT */)
                        ]))
                      : _createCommentVNode("v-if", true)
                  ])
                ]),
                (cs.IsCollapsed === false)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(cs.Scenarios, (ps) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: ps.Id
                      }, [
                        _createElementVNode("td", null, [
                          _createElementVNode("div", _hoisted_19, [
                            _cache[10] || (_cache[10] = _createElementVNode("button", {
                              type: "button",
                              class: "btn btn-outline-secondary",
                              "data-toggle": "dropdown"
                            }, [
                              _createElementVNode("i", { class: "fa-solid fa-ellipsis" })
                            ], -1 /* CACHED */)),
                            _createElementVNode("div", _hoisted_20, [
                              _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_21, [...(_cache[8] || (_cache[8] = [
                                _createTextVNode("View", -1 /* CACHED */)
                              ]))])), [
                                [_directive_sanitizedHref, `/#/portfolio-plan/projects/${workspaceId.value}/${tchProjectId.value}/${ps.Id}`]
                              ]),
                              _createElementVNode("a", {
                                class: "dropdown-item",
                                onClick: ($event: any) => (showPortfolioScenarioEditor(ps))
                              }, "Settings", 8 /* PROPS */, _hoisted_22),
                              _createElementVNode("a", {
                                class: "dropdown-item",
                                onClick: ($event: any) => (handleClonePortfolioScenarioCommand(ps))
                              }, "Clone", 8 /* PROPS */, _hoisted_23),
                              _cache[9] || (_cache[9] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                              _createElementVNode("a", {
                                class: "dropdown-item",
                                onClick: ($event: any) => (handleDeletePortfolioScenarioCommand(ps.Id))
                              }, "Delete", 8 /* PROPS */, _hoisted_24)
                            ])
                          ])
                        ]),
                        _createElementVNode("td", null, [
                          _cache[11] || (_cache[11] = _createElementVNode("span", { class: "badge badge-secondary float-right" }, "Portfolio plan", -1 /* CACHED */)),
                          _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_25, [
                            _createTextVNode(_toDisplayString(ps.Name), 1 /* TEXT */)
                          ])), [
                            [_directive_sanitizedHref, `/#/portfolio-plan/projects/${workspaceId.value}/${tchProjectId.value}/${ps.Id}`]
                          ]),
                          _cache[12] || (_cache[12] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                          _createElementVNode("small", _hoisted_26, "Created: " + _toDisplayString(formatDate(ps.CreatedDate)) + ", " + _toDisplayString(formatTime(ps.CreatedDate)) + " by " + _toDisplayString(ps.CreatedByName), 1 /* TEXT */),
                          _createElementVNode("div", null, [
                            _createElementVNode("small", null, _toDisplayString(ps.Description), 1 /* TEXT */)
                          ])
                        ])
                      ]))
                    }), 128 /* KEYED_FRAGMENT */))
                  : _createCommentVNode("v-if", true),
                (cs.IsCollapsed === false)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_27, [
                      _createElementVNode("td", _hoisted_28, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-secondary",
                          onClick: ($event: any) => (showPortfolioScenarioCreator(cs.Id))
                        }, " Create portfolio plan ", 8 /* PROPS */, _hoisted_29)
                      ])
                    ]))
                  : _createCommentVNode("v-if", true)
              ])
            ]))
          }), 128 /* KEYED_FRAGMENT */))
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})